import { FC } from "react";
import { Box, Flex, Heading, SystemProps } from "@storyofams/react-ui";
import { SeeMoreButton } from "../../common/Story/molecules/TitleCombo";

interface CircleProps extends SystemProps {
  content?: {
    Active: boolean;
    Post_slug: string;
    Space_slug: string;
  };
}

export const Circle: FC<CircleProps> = ({ content }) => {
  if (content.Active) {
    const url = `https://community.naturalheroes.nl/c/${content.Space_slug}/${content.Post_slug}`;
    return (
      <Box id="reviews" width={"100%"} height="100%">
        <Flex
          justifyContent="space-between"
          alignItems="flex-end"
          width={"100%"}
        >
          <Box>
            <Heading variant="h4" as={"h1"}>
              Opmerkingen
            </Heading>
          </Box>
          <SeeMoreButton link={url}>Ga naar onze community</SeeMoreButton>
        </Flex>
        <Box mx="auto" mt="30px" height={"100%"}>
          <iframe
            id="iframe"
            loading="lazy"
            title="circle"
            width={"100%"}
            height={700}
            src={url.concat("?iframe=true&?post=false")}
            style={{ height: 700, border: "none", maxHeight: 1020 }}
          />
        </Box>
      </Box>
    );
  }

  return null;
};
